import { useContext, useState, useRef, useEffect } from "react";
import Button from "../form/Button";
import Input from "../form/Input";
import { MessageContext } from "../../../providers/MessageProvider";
import Dropdown from "../form/Dropdown";

export default function MessagesDisplay() {
	const { 
		isOpen,
		title,
		isYesNo,
		isInput,
		isOkCancel,
		message,
		onClose,
		inputValue,
		setInputValue,
		selectionData,
		selectionValue,
		setSelectionValue
	} = useContext(MessageContext);
	const [focusIndex, setFocusIndex] = useState(true);
	const yesRef = useRef(null);
	const noRef = useRef(null);

	useEffect(() => {
		if (!isOpen) {
			setFocusIndex(true);
			setSelectionValue(-1);
		}
	}, [isOpen]);

	if (isOpen) {
		return (
			<div className={`absolute content-end h-screen w-screen z-[150] bg-light-0/50 backdrop-blur-sm`}>
				<div className="absolute inset-x-8 sm:inset-x-8 top-44 sm:bottom-8 sm:w-96 sm:left-[50%] sm:-translate-x-[50%]">
					<div className="flex flex-col rounded bottom-0 overflow-hidden bg-light-8 font-bold shadow-lg"
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								e.preventDefault();
								if (isInput) { 
									if (inputValue) {
										onClose(inputValue);
									} else {
										onClose(false);
									}
								} else if (selectionValue > -1) {
									onClose(selectionValue);
								} else if (isYesNo || isOkCancel) {
									onClose(focusIndex);
								} else {
									onClose(false);
								}
							}
							if (!isInput && (e.key === "ArrowRight" || e.key === "ArrowLeft")) {
								if (focusIndex) {
									noRef.current.focus();
								} else {
									yesRef.current.focus();
								}
								setFocusIndex(!focusIndex);
							}
						}}
					>
						<div className="flex justify-between min-h-[24px] bg-light-5 p-1 px-4 font-semibold text-sm sm:text-base">
							{title}
						</div>
						<div className="flex py-0 px-4 pt-1 font-normal text-sm sm:text-base">
							{message}
						</div>
						{isInput &&
							<div>
								<Input autoFocus className="mx-4 mb-2" classInner="h-8 font-normal" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
							</div>
						}
						{selectionData.length > 0 &&
							<div className="flex h-[170px]">
								<Dropdown
									className="w-full mx-4 font-normal"
									vertSize="max-h-32"
									options={selectionData}
									value={selectionValue}
									onChange={(e) => setSelectionValue(e.target.value)}
								/>
							</div>
						}
						<div className="flex flex-row justify-end items-end gap-2 bg-light-4/30 text-light-2 font-normal p-1 px-4">
							{(isYesNo || isOkCancel) && 
								<>
									<Button
										ref={yesRef}
										{...!isInput && {autoFocus: true}}
										isdefault={true}
										className={`h-6 w-20 focus:bg-light-3/70`}
										text={`${isYesNo ? "Yes" : "Ok"}`}
										onClick={() => isInput ? onClose(inputValue) : selectionValue > -1 ? onClose(selectionValue) : onClose(true)}
									/>
									<Button 
										ref={noRef}
										className={`h-6 w-20 focus:bg-light-3/70`} text={`${isYesNo ? "No" : "Cancel"}`}
										onClick={() => onClose(false)}
									/>
								</>
							}
							{!isYesNo && !isOkCancel &&!isInput &&
								<Button className="h-6 w-20" text="Ok" isdefault={true} onClick={() => onClose(true)}/>
							}
						</div>
					</div>
				</div>
			</div>
		)
	}
}